import {
  Box,
  Card,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  },
  body: {
    fontSize: 14,
    whiteSpace: 'normal',
    wordBreak: 'break-word'
  },
  root: {
    padding: '12px 6px'
  }
}))(TableCell);

const Results = ({ className, listFeedbacks, getListFeedbacksRef }) => {
  const classes = useStyles();
  const [limit, setLimit] = useState(PAGE_SIZE_LIST);
  const [page, setPage] = useState(1);
  const totalFeedback = useSelector(state => state.customerSlice.totalFeedback);

  const [params, setParams] = useState({
    page: page,
    page_size: limit
  });

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListFeedbacksRef) return;
    const newparams = Object.assign({}, params, { page: newPage });
    setParams(newparams);
    getListFeedbacksRef(newparams);
  };

  return (
    <>
      <Card className={clsx(classes.root, className)}>
          <div>
            <PerfectScrollbar>
              {listFeedbacks && listFeedbacks.length > 0 ? (
                <Box minWidth={1050}>
                  <Table>
                    {listFeedbacks?.length > 0 && (
                      <TableHead>
                        <TableRow>
                          <StyledTableCell style={{ width: 300 }}>Tên người dùng</StyledTableCell>
                          <StyledTableCell style={{ width: 200 }}>Số điện thoại</StyledTableCell>
                          <StyledTableCell style={{ width: 600 }}>Nội dung phản hồi</StyledTableCell>
                          <StyledTableCell style={{ width: 150 }}>Thời gian phản hồi</StyledTableCell>
                        </TableRow>
                      </TableHead>
                    )}
                    <TableBody>
                      {listFeedbacks.map((feedback, index) => (
                        <TableRow hover key={feedback.id}>
                          <StyledTableCell>
                            {feedback?.user?.full_name || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {feedback?.user?.phone || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {feedback?.comment || '--'}
                          </StyledTableCell>         
                          <StyledTableCell>
                             {new Date(feedback?.created_at).toLocaleDateString(
                              'vi-VN'
                            )}
                          </StyledTableCell>         
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              ) : (
                <div className="text-center pb-5">
                  <img src="/static/empty.png" class="justify-content-center" />
                  <h4> Danh sách trống </h4>
                </div>
              )}
            </PerfectScrollbar>
          </div>
      </Card>
      {listFeedbacks && listFeedbacks.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalFeedback}
            </Typography>
            <Pagination
              count={Math.ceil(totalFeedback / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page)}
              showFirstButton
              showLastButton
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listUser: PropTypes.array.isRequired
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default Results;
